import { useQueries } from "@tanstack/react-query";
import { PickerStatsApi, ProcessorStatsApi } from "../../services/http-service/tableStats";
import { getPickerTableColumns, getProcessorTableColumns } from "./columns";

export const statTableApi = () => {
  const [pickerStatsQuery, processorStatsQuery] = useQueries({
    queries: [
      {
        queryKey: ["pickerStatsTable"],
        queryFn: async () => await PickerStatsApi(),
        enabled: true,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchInterval: 10000,
      },
      {
        queryKey: ["processorStatsTable"],
        queryFn: async () => await ProcessorStatsApi(),
        enabled: true,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchInterval: 10000,
      },
    ],
  });

  const {
    isLoading: pickerStatsLoading,
    isFetching: isFetchingPickerTableData,
    isError: isErrorPickerTableData,
    data: pickerStatsData,
    error: pickerStatsError,
    refetch: refetchpickerTabledata,
  } = pickerStatsQuery;

  const {
    isLoading: processorStatsLoading,
    isFetching: isFetchingProcessorTableData,
    isError: isErrorProcessorTableData,
    data: processorStatsData,
    error: processorStatsError,
    refetch: refetchprocessorTabledata,
  } = processorStatsQuery;

  const pickerStatsColumns = getPickerTableColumns("pickerStats");
  const processorStatsColumns = getProcessorTableColumns("processorStats");

  const pickerStatsRows = pickerStatsData
    ? pickerStatsData.map((statData, key) => ({
        key: key,
        id: key,
        userId: statData.userId,
        ordersPickedPerHour: statData.ordersPickedPerHour,
        totalOrdersPicked: statData.totalOrdersPicked,
        totalPoints: statData.totalPoints,
        // Add additional row data if needed
      }))
    : [];

  const processorStatsRows = processorStatsData
    ? processorStatsData.map((processData, key) => ({
        key: key,
        id: key,
        userId: processData.userId,
        ordersProcessedPerHour: processData.ordersProcessedPerHour,
        totalOrderProcessed: processData.totalOrderProcessed,
        totalPoints: processData.totalPoints,
        // Add additional row data if needed
      }))
    : [];

  const StatsTable = [
    {
      header: "PickerStats Table",
      columns: pickerStatsColumns,
      rows: pickerStatsRows,
      isLoadingStatTable: pickerStatsLoading,
      isErrorStatTable: isErrorPickerTableData,
      secondaryHeader: {
        secondaryHeaderCount: pickerStatsData ? pickerStatsData.reduce((total, stat) => total + stat.totalOrdersPicked, 0) : 0,
        secondaryHeaderText: "Total Items Picked:",
      },
    },
    {
      header: "ProcessorStats Table",
      columns: processorStatsColumns,
      rows: processorStatsRows,
      isLoadingStatTable: processorStatsLoading,
      isErrorStatTable: isErrorProcessorTableData,
      secondaryHeader: {
        secondaryHeaderCount: processorStatsData
          ? processorStatsData.reduce((total, processData) => total + processData.totalOrderProcessed, 0)
          : 0,
        secondaryHeaderText: "Total Items Processed:",
      },
    },
  ];

  return StatsTable;
};
